import "core-js/modules/es.number.constructor.js";
import ConfirmPopover from "./ConfirmPopover.vue";
export default {
  name: 'ConfirmOrder',
  components: {
    ConfirmPopover: ConfirmPopover
  },
  props: {
    title: String,
    content: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    width: {
      type: [String, Number],
      default: 250
    },
    placement: {
      type: String,
      default: 'top'
    },
    trigger: {
      type: String,
      default: 'click'
    },
    popperClass: {
      type: String,
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    isConfirm: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    isTrue: function isTrue() {
      var _this$row;
      return ((_this$row = this.row) === null || _this$row === void 0 ? void 0 : _this$row.slipIdentical) === '1';
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },
  methods: {
    confirmOrRefund: function confirmOrRefund() {
      var _this$$refs;
      (_this$$refs = this.$refs) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs.confirmPopover) === null || _this$$refs === void 0 || _this$$refs.cancel();
      this.emitConfirm();
    },
    cancel: function cancel() {
      var _this$$refs2;
      this.visible = false;
      (_this$$refs2 = this.$refs) === null || _this$$refs2 === void 0 || (_this$$refs2 = _this$$refs2.confirmPopover) === null || _this$$refs2 === void 0 || _this$$refs2.cancel();
    },
    confirm: function confirm() {
      if (this.isConfirm ? !this.isTrue : this.isTrue) return;
      this.emitConfirm();
    },
    emitConfirm: function emitConfirm() {
      this.loading = true;
      this.$emit('confirm', this.confirmCallback);
      this.visible = false;
    },
    confirmCallback: function confirmCallback(success) {
      this.loading = false;
      if (success) {
        this.visible = false;
      }
    },
    previewImg: function previewImg(src) {
      this.$hevueImgPreview({
        multiple: true,
        nowImgIndex: 0,
        imgList: [src]
      });
    }
  }
};